import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtual from '../../actions/empresa/determinarPaginaAtualEmpresas'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoEmpresas extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualEmpresa,
    total: state.empresasGestao.total,
    registrosPorPagina: state.registrosPorPaginaEmpresa
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoEmpresas)
